import { Trans } from '@lingui/macro';
import { Container } from './styled';
export function SkipDocumentContent(props) {
    const { target } = props;
    return (<Container href={`#${target}`}>
      <Trans>Skip to end of document content</Trans>
    </Container>);
}
